<template>
  <div class="margin-general">
    <div class="do-for-you-content">
      <div class="do-for-you-left">
        <div class="text-box">
          <h2 v-html="formatContent(title, $t)"></h2>
          <div v-for="(paragraph, index) in paragraphs" :key="index">
            <p class="description">
              <span v-for="(part, partIndex) in paragraph" :key="partIndex">
                <strong v-if="part.strong">{{ part.text }}</strong>
                <span v-else>{{ part.text }}</span>
              </span>
            </p>
          </div>
          <!-- Renderizar imagen solo si imageSrc existe -->
          <img 
            v-if="imageSrc" 
            :src="imageSrc" 
            :alt="imageAlt || 'Image not available'" 
            @error="handleImageError" 
          />
        </div>
      </div>
      <div class="do-for-you-right">
        <div v-for="(item, index) in cards" :key="index" class="card">
          <div class="img-content">
            <div class="img-box">
              <span class="material-symbols-outlined" translate="no">{{ item.icon }}</span>
            </div>
          </div>
          <div class="text-content">
            <p class="description"><strong>{{ item.description }}</strong> {{ item.description1 }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { formatContent } from '~/utils/formatContent';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  paragraphs: {
    type: Array,
    required: false,
    default: () => [],
  },
  cards: {
    type: Array,
    required: true,
  },
  imageConfig: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  imageAlt: {
    type: String,
    required: false,
    default: '',
  },
});

// Computar la fuente de la imagen solo si hay configuración
const imageSrc = computed(() => {
  const locale = 'locale.key'; // Simular una clave de idioma actual
  return props.imageConfig[locale]?.image || props.imageConfig.default?.image || null;
});

// Método para manejar errores de imagen rota
const handleImageError = (event) => {
  event.target.style.display = 'none'; // Ocultar la imagen si está rota
};
</script>